<template>
  <ContextMenu :id="id" :items="menu" align="right" />
</template>

<script>
import ContextMenuMixin from "mixins/ContextMenu";
import EnrollmentMixin from "mixins/Events/HandlesEventEnrollment";
import EventRequestCalendar from "components/pages/registration/classroom/partials/EventRequestCalendar";
import DisplaysAlerts from 'mixins/DisplaysAlerts'
import SendEmailModal from "components/partials/Events/EmailRosterModal"

export default {
  mixins: [DisplaysAlerts, ContextMenuMixin, EnrollmentMixin],

  props: {
    mobile: { type: Boolean, default: false },
    section: { type: String, default: "training" },
  },

  computed: {
    routeParam() {
      return { event: this.item.id };
    },

    enrollmentsRoute() {
      return this.section == "admin"
        ? "admin.events.enrollments.index"
        : "training.events.enrollments.index";
    },

    menu() {
      if (this.mobile) {
        return this.mobileMenu;
      }

      let menu = [];

      if (this.section == "admin") {
        menu.push({
          label: "Edit",
          action: () => {
            this.goToRoute("admin.events.edit", this.routeParam);
          },
        });
        if (!!this.item.can_delete) {
          menu.push({
            label: "Remove",
            action: () => {
              this.doAction("remove");
            },
          });
        }
        if (!!this.item.can_export_surveys) {
          menu.push({
            label: "View Survey Responses",
            action: () => {
              this.goToRoute(
                "admin.events.surveys.submissions.index",
                this.routeParam
              );
            },
          });
        }
      }

      if (!["CLOSED", "PENDING_CLOSE"].includes(this.item.status)) {
        menu.push({
          label: "Add to My Calendar",
          action: () => {
            this.goToRoute("event-calendar.ics", this.routeParam);
          },
        });
      }

      menu.push({
        label: "Details",
        action: () => {
          this.showDetailsPane("details");
        },
      });

      if (!!this.item.show_trainer_bio) {
        menu.push({
          label: "Trainer Bio",
          action: () => {
            this.showDetailsPane("trainer");
          },
        });
      }

      if (!!this.item.show_downloads) {
        menu.push({
          label: "Downloads",
          action: () => {
            this.showDetailsPane("downloads");
          },
        });
      }

      if (!!this.item.show_shipping) {
        menu.push({
          label: "Shipping",
          action: () => {
            this.showDetailsPane("shipping");
          },
        });
      }

      if (!!this.item.can_request_event) {
        menu.push({
          label: "Request an Event",
          action: () => {
            this.showRequestAnEvent();
          },
        });
      }

      if (!!this.item.can_enroll) {
        menu.push({
          label: "Register Myself",
          action: () => {
            this.enrollMyself(this.item);
          },
        });
      }
      // else if (!!this.item.can_enroll_error) {
      //   menu.push({
      //     label: "Register Myself",
      //     action: () => {
      //       this.showError(this.item.can_enroll_error);
      //     },
      //   });
      // }

      if (!!this.item.can_enroll_others) {
        menu.push({
          label: "Register Others",
          action: () => {
            this.enrollOthers(this.item);
//            this.goToRoute("enroll.classroom.event.others", this.routeParam);
          },
        });
      }
      // else if (!!this.item.can_enroll_others_error) {
      //   menu.push({
      //     label: "Register Others",
      //     action: () => {
      //       this.showError(this.item.can_enroll_others_error);
      //     },
      //   });
      // }

      if (!!this.item.can_view_enrollments) {
        menu.push({
          label: "View Roster",
          action: () => {
	          this.showDetailsPane("roster");
//            this.goToRoute(this.enrollmentsRoute, this.routeParam);
          },
        });
      }

      if (!!this.item.can_upload_roster) {
        menu.push({
          label: "Upload Sign-in Sheet",
          action: () => {
            this.goToRoute(this.enrollmentsRoute, this.routeParam);
          },
        });
      }

      if (!!this.item.can_upload_flyer) {
        menu.push({
          label: "Upload Event Flyer",
          action: () => {
            this.goToRoute(this.enrollmentsRoute, this.routeParam);
          },
        });
      }

      if (!!this.item.can_print_roster) {
        menu.push({
          label: "Print Roster",
          action: () => {
            this.printRoster();
          },
        });
      }

      if (!!this.item.can_print_certificates) {
        menu.push({
          label: "Print All Certificates",
          action: () => {
            this.goToRoute(
              "training.events.certificates",
              this.routeParam,
              true
            );
          },
        });
      }

      if (!!this.item.can_cancel) {
        menu.push({
          label: "Cancel Event",
          action: () => {
              this.doAction("cancel");
          },
        });
      }

      if (!!this.item.can_update && this.section != "admin") {
        menu.push({
          label: "Edit Event",
          action: () => {
            this.goToRoute("training.events.edit", this.routeParam);
          },
        });
      }

      if (!!this.item.can_email_roster) {
        menu.push({
          label: "Send Email",
          action: () => {
            this.showSendEmailModal()
          },
        });
      }

      // if (!!this.item.can_rsvp) {
      //   menu.push({
      //     label: "Trainer RSVP",
      //     action: () => {
      //       alert("@todo...");
      //     },
      //   });
      // }

      if (!!this.item.can_export_surveys) {
        menu.push({
          label: "Export Survey Summary",
          action: () => {
              this.goToRoute("surveys.event.summary", this.routeParam);
          },
        });
      }

      // if (!!this.item.can_export_tests) {
      //   menu.push({
      //     label: "Export Test Results",
      //     action: () => {
      //       alert("@todo...");
      //     },
      //   });
      // }

      menu.sort(this.sortMenu);
      return menu;
    },

    mobileMenu() {
      let menu = [];

      menu.push({
        label: "Add to My Calendar",
        action: () => {
          this.goToRoute("event-calendar.ics", this.routeParam);
        },
      });

      if (!!this.item.can_enroll) {
        menu.push({
          label: "Register Myself",
          action: () => {
            this.enrollMyself(this.item);
          },
        });
      }
      // else if (!!this.item.can_enroll_error) {
      //   menu.push({
      //     label: "Register Myself",
      //     action: () => {
      //       this.showError(item.can_enroll_error);
      //     },
      //   });
      // }

      if (!!this.item.can_enroll_others) {
        menu.push({
          label: "Register Others",
          action: () => {
            this.goToRoute("enroll.classroom.event.others", this.routeParam);
          },
        });
      }
      // else if (!!this.item.can_enroll_others_error) {
      //   menu.push({
      //     label: "Register Others",
      //     action: () => {
      //       this.showError(item.can_enroll_others_error);
      //     },
      //   });
      // }

      if (!!this.item.can_view_enrollments) {
        menu.push({
          label: "View Roster",
          action: () => {
	          this.showDetailsPane("roster");
//            this.goToRoute(this.enrollmentsRoute, this.routeParam);
          },
        });
      }

      if (!!this.item.can_cancel) {
        menu.push({
          label: "Cancel Event",
          action: () => {
            alert("@todo...");
          },
        });
      }

      if (!!this.item.can_update && this.section != "admin") {
        menu.push({
          label: "Edit Event",
          action: () => {
            this.goToRoute("training.events.edit", this.routeParam);
          },
        });
      }

      if (!!this.item.can_email_roster) {
        menu.push({
          label: "Send Email",
          action: () => {
              this.showSendEmailModal();
          },
        });
      }

      if (!!this.item.can_rsvp) {
        menu.push({
          label: "Trainer RSVP",
          action: () => {
            alert("@todo...");
          },
        });
      }

      menu.sort(this.sortMenu);
      return menu;
    },
  },

  methods: {
    printRoster() {
      var url = this.route(
        "training.events.enrollments.print",
        this.routeParam
      );
      url += "?pagination[current]=1";
      url += "&pagination[per_page]=1000";
      url += "&sort[column]=" + encodeURIComponent("user.name");
      url += "&sort[dir]=asc";
      window.open(url, "_blank");
    },

    showRequestAnEvent() {
      this.$modal(EventRequestCalendar, { course: this.item.course })
        .then(() => {})
        .catch(() => {});
    },

    showSendEmailModal() {
        this.$modal(SendEmailModal, { event: this.item })
    }
  },
};
</script>